module.exports = __webpack_public_path__ + "static/img/carOwner.ac4a71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/carOwner.png
// module id = Fan6
// module chunks = 225